import {isArray} from "my-tools-kit";
/**
 * 校验 产品报价设置 仅保存
 * @returns {*[]|boolean}
 */
export function checkSaveData(){
  let details = this.logisticsProductsDetails || {};
  let editFormData = this.editFormData||{};
  let options = {
    // 是否分段报价
    isSegment: details.isSegment,
    // 是否多渠道
    isSupportMultiChannel: editFormData.isSupportMultiChannel,
    isConvertOnPartition: this.isConvertOnPartition
  };
  // 校验时错误提示文本集合
  let errorArray = [];
  // 校验步骤
  let checkStep = [
    // 有效时间
    () => checkEffectiveTime(editFormData),
    // 运力商产品
    () => checkHasSelectSupplierProduct(editFormData),
    // 是否有选择货物入仓测量方式、是否支持线下议价、是否支持时效赔付
    () => checkHasSelectLabel(editFormData),
    // 全包/头程 城市分区列表
    () => checkCityRegionList(this.cityRegionHeaderList,options),
    // 派送分区列表
    () => checkDeliveryRegionList(this.deliveryRegionHeaderList,options,editFormData),
  ]
  console.log(this.deliveryRegionHeaderList)
  let result = startCheckStep(checkStep);
  receiveCheckResult(result,errorArray);

  return errorArray.length ? errorArray : true;
}

/**
 * 启动检查步骤
 * @param stepArray {Array<Function|Boolean|String>} 校验程序集
 * @returns {*[]|boolean}
 */
export function startCheckStep(stepArray = []){
  // 校验时错误提示文本集合
  let errorArray = [];
  for (let fun of stepArray){
    let result;
    if(typeof fun === "function") result = fun();
    else result = fun;
    receiveCheckResult(result,errorArray);
    if(errorArray.length) return errorArray;
  }
  return errorArray.length ? errorArray : true;
}

/**
 * 接收校验结果
 * @param result  {Array<String>|Boolean} 新的校验结果
 * @param errorArray  {Array<String>} 已汇总的错误提示文本集
 * @param beforeLabel  {String} (选填)需要拼接在每条新的错误提示文本前的文本
 */
export function receiveCheckResult(result = true,errorArray=[],beforeLabel=""){
  if(!isArray(errorArray)) errorArray = [];
  if(isArray(result)) {
    if(beforeLabel){
      result.forEach(item=>{
        errorArray.push(beforeLabel + item);
      })
    }else{
      errorArray.push(...result);
    }
  }
  return errorArray;
}
/**
 * 校验有效时间
 * @param editFormData
 */
export function checkEffectiveTime(editFormData={}){
  let errorArray = [];
  if(!editFormData.effectiveStartTime || !editFormData.effectiveEndTime) errorArray.push("请选择 有效时间");
  return errorArray.length ? errorArray : true;
}
/**
 * 是否有下拉选择 运力商产品
 * @param editFormData
 */
export function checkHasSelectSupplierProduct(editFormData={}){
  let errorArray = [];
  if(!editFormData.logisticsProductCarrierId) errorArray.push("请选择 运力商产品名称");
  return errorArray.length ? errorArray : true;
}
/**
 * 是否有选择货物入仓测量方式
 * @param {*} editForm
 * @returns
 */
export function checkHasSelectLabel(editForm={}) {
  let errorArray = [];
  if (!editForm.goodsMeasurementMethod) errorArray.push("请选择 货物入仓测量方式");
  return errorArray.length ? errorArray : true;
}

/**
 * 校验城市维度区间列表是否满足保存规则，
 * 规则: cityRegionList可以为空
 * 规则：cityRegionItem下的 区间列表（regionHeaderList）不能为空
 * 规则：regionItem必须要选择至少一个分区信息
 * @param list {Array}  城市区间列表
 * @param options {Object}  其他参数
 * @returns {*[]|boolean}
 */
function checkCityRegionList(list=[],options){
  console.log(list)
  let {
    isSegment,// 是否是分段报价
    isSupportMultiChannel,// 是否多渠道
    type="head",// 分段类型：head-全包(头程) delivery-派送
  } = options;
  let errorArray = [];
  if(!(isArray(list) && list.length)) return true;
  let _typeName = `分区设置（${isSegment ? "头程":"全包"}） `;
  list.every((item,index)=>{
    let labelText = `${_typeName} 第${index+1}条城市区间 `;
    // 有选择起运城市
    let hasCityList = isArray(item.cityList) && item.cityList.length;
    // 有分区列表数据
    let hasRegionList = isArray(item.regionHeaderList) && item.regionHeaderList.length;
    if(hasCityList){
      if(!hasRegionList){
        errorArray.push(`${labelText} 分区列表 不能为空`);
        return false;
      }
      // 分区列表
      let result = checkHeadRegionList(item.regionHeaderList,options);
      if(isArray(result)){
        receiveCheckResult(result,errorArray,labelText);
        return false;
      }
    }else if(hasRegionList){
      errorArray.push(`${labelText} 起运城市 不能为空`);
      return false;
    }
    return true;
  });

  return errorArray.length ? errorArray : true;
}
/**
 * 校验 全包/头程 的区间列表是否满足保存规则，
 * 规则：regionItem必须要选择至少一个分区信息
 * @param list {Array}  城市区间列表
 * @param options {Object}  其他参数
 * @returns {*[]|boolean}
 */
function checkHeadRegionList(list=[],options){
  let errorArray = [];
  let {
    isSegment,// 是否是分段报价
    isSupportMultiChannel,// 是否多渠道
    type="head",// 分段类型：head-全包(头程) delivery-派送
    isConvertOnPartition=false
  } = options;
  if(isArray(list) && list.length){
    list.every((item,index)=>{
      let label = `第${index+1}个分区 `;
      if(!(isArray(item.regionDetailList) && item.regionDetailList.length)){
        errorArray.push(label + "分区信息列表 不能为空");
        return false;
      }
      return item.priceDetailList.every((regionDetailsItem,i)=>{
        let _label = label + `第${i+1}条分区明细 `
        if(!(isArray(regionDetailsItem.goodsTypeList) && regionDetailsItem.goodsTypeList.length)){
          errorArray.push(_label + "可走货物类型 不能为空");
          return false;
        }
        if (isConvertOnPartition) {
          const ratio = item.chargeType === 'KG' ? regionDetailsItem.volumeWeightRatio : regionDetailsItem.weightVolumeRatio
          if (!ratio) {
            const ratioName = item.chargeType === 'KG' ? '体积重比率' : '重量转换'
            errorArray.push(_label + ratioName + " 不能为空");
            return false;
          }
        }
        return true;
      })
    });
  }else{
    errorArray.push("分区列表 不能为空");
  }
  return errorArray.length ? errorArray : true;
}

/**
 * 校验 派送 的区间列表是否满足保存规则，
 * @param list
 * @param options
 * @param editFormData
 */
function checkDeliveryRegionList(list=[],options,editFormData){
  let errorArray = [];
  let {
    isSegment,// 是否是分段报价
    isSupportMultiChannel,// 是否多渠道
    type="delivery",// 分段类型：head-全包(头程) delivery-派送
  } = options;
  if(!isSegment) return true;
  if(editFormData.deliveryType === "ZT") return true;
  let _typeName = `分区设置（派送） `;

  if(isArray(list) && list.length){
    list.forEach((item,index)=>{
      let label = `${_typeName} 第${index+1}个分区 `;
      if(!(isArray(item.regionDetailList) && item.regionDetailList.length)){
        errorArray.push(label + "分区信息列表 不能为空");
        return false;
      }
    });
  }


  // let result = checkHeadRegionList(list,options);
  // receiveCheckResult(result,errorArray,_typeName);
  return errorArray.length ? errorArray : true;
}

/**
 * 校验 是否推送更新至收藏客户 及 更新说明
 */
function checkPushOpen(editFormData={}){
  let errorArray = [];
  if(editFormData.pushOpen || !editFormData.pushContent) errorArray.push("已勾选推送更新至收藏客户，请填写更新说明");
  return errorArray.length ? errorArray : true;
}





// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/utils/checkSave.utils.js